// extracted by mini-css-extract-plugin
export default {"coverLink":"lL-z","contentBox":"mL-z","zapposPromoContainer":"nL-z","zapposPromoGroupContainer":"oL-z","promos":"pL-z","bottom":"qL-z","top":"rL-z","right":"sL-z","left":"tL-z"};